module.exports = __webpack_public_path__ + "static/img/home_product3@2x.d1db359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productIntroduction/home_product3@2x.png
// module id = YEfD
// module chunks = 0